import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthSelectorsFacade } from '../state/auth.selectors.facade';

export const authGuard: CanActivateFn = () => {
  const isAuthenticated = inject(AuthSelectorsFacade).isAuthenticated;

  if (isAuthenticated()) {
    return true;
  }

  return inject(Router).createUrlTree(['/login']);
};
